import {neverland as $, render, html, useState, useEffect} from 'neverland';
import { isAuthenticated, getCurrentUser, getCredentials } from '../lib/cognito.js';
import database from '../lib/database.js';

import StyleSheet from './StyleSheet.js';
import Router from './Router.js'

const App = $(function() {
	let pageId = (new URLSearchParams(window.location.search)).get('p');
	
	const [auth, setAuth] = useState({
		user: null,
		db: database
	});
	
	let [theme, setTheme] = useState(null);
	let [endScreen, setEndScreen] = useState(null);

	let [page, setPage] = useState({
		id: pageId,
		survey: null
	});

	let [a11y, setA11y] = useState({ noBg: false, highContrast: 100, largeText: window.innerWidth <= 600 ? 12 : 16, reducedMotion: false });

	useEffect(() => {
		const htmlEl = document.documentElement;
		htmlEl.classList.toggle('a11y-no-bg', a11y.noBg);
		htmlEl.classList.toggle('a11y-reduced-motion', a11y.reducedMotion);
		htmlEl.style.setProperty('--a11y-contrast', `${a11y.highContrast}%`);
		htmlEl.style.fontSize = `${a11y.largeText}px`;
	}, [a11y]);

	let href = window.location.href;

	async function login() {
		try {
			const credentials = await getCredentials();
			AWS.config.credentials = credentials;
			
			setAuth(prevAuth => ({
				...prevAuth,
				user: getCurrentUser()
			}));

			return getCurrentUser();
		} catch(err) {
			console.warn('Authentication failed:', err);
			return null;
		}
	}

	async function loadTheme(user) {
		if (!user) return;
		
		try {
			const themes = await auth.db.collection('Themes').find({ "domains.hostname": window.location.hostname });
			if (themes.length > 0) {
				setTheme(themes[0]);
			}

			if (page.id === 'EndScreen') {
				let endScreenId = (new URLSearchParams(window.location.search)).get('s');
				if (endScreenId === null) {
					endScreenId = "613bf31aea98708b5101b477";
				}

				const endScreens = await auth.db.collection('EndScreens').find({ _id: {$oid: endScreenId }});
				if (endScreens.length > 0) {
					setEndScreen(endScreens[0]);
				}
			}
		} catch(err) {
			console.warn('Failed to load theme/endscreen:', err);
		}
	}

	useEffect(() => {
		login().then(loadTheme);
	}, [])

	useEffect(() => {
		if (theme !== null) {
			if (theme.hasOwnProperty('favicon')) {
				let fileType = theme.favicon.split('.')[1];

				document.getElementsByTagName("head")[0].insertAdjacentHTML(
					"beforeend",
					`<link rel="icon shortcut" type="image/${fileType}" href="static/img/favicons/${theme.favicon}" />`
				);
			}
		}
	}, [theme])

	return html`
		${StyleSheet(theme)}
		${Router(href, auth, theme, endScreen, page, setPage, a11y, setA11y)}
	`;

});

export default App;